<script setup lang="ts">
import { twMerge } from "tailwind-merge"

const props = defineProps<{ class?: string }>()
</script>

<template>
  <strong :class="twMerge('font-medium', props.class)"><slot /></strong>
</template>
